package er.prateek.crossly.data.model

import kotlinx.serialization.Serializable

@Serializable
data class PackManifestEntry(
    val packId: String,
    val type: String = "CROSSWORD",
    val difficulty: DifficultyTier,
    val version: Int,
    // Absolute, or relative to the manifest's own base URL.
    val url: String,
    // Hex-encoded SHA-256 of the pack file's raw bytes.
    val checksum: String,
    val bundled: Boolean = false,
)

@Serializable
data class ContentManifest(
    val schemaVersion: Int = 1,
    val packs: List<PackManifestEntry> = emptyList(),
    // e.g. "https://cdn.example.com/daily/{date}.json" -- "{date}" is replaced
    // with the current UTC date (ISO-8601, yyyy-MM-dd).
    val dailyPuzzleUrlTemplate: String? = null,
    val featureFlags: Map<String, Boolean> = emptyMap(),
)
